<template>
  <div>
    <p v-if="value" class="font-italic fontSize">
      {{ $t("components.basicHistory.createAt") }}
      {{ value.createAt ? value.createAt : "" | moment }}
      {{ $t("components.basicHistory.createBy") }}
      {{ value.createBy ? value.createBy : "" }}
    </p>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    value: {
      default() {
        return {
          createAt: "",
          createBy: "",
        };
      },
    },
  },
  filters: {
    moment: function(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style>
.fontSize {
  font-size: 0.7em;
}
</style>
